var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header'),_c('div',{staticClass:"main-content"},[_c('router-view',{key:_vm.$route.fullPath})],1),_c('Foot')],1)}
var staticRenderFns = []

export { render, staticRenderFns }